module.exports = __webpack_public_path__ + "static/media/WhoWeAre_Banner.985afa3c.jpg";